var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EEF0F3",
    cx: 32,
    cy: 27.539,
    r: 13.873
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#848992",
    strokeWidth: 1.2,
    cx: 32,
    cy: 27.539,
    r: 13.273
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#848992",
    strokeWidth: 1.2,
    cx: 32,
    cy: 32,
    r: 31.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.393 57.108c2.65-16.87 28.273-26.053 37.222 0",
    stroke: "#848992",
    strokeWidth: 1.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLarge);
export default __webpack_public_path__ + "static/media/accountLarge.4a4ae57c57ff6336559ae5617a8732b2.svg";
export { ForwardRef as ReactComponent };